export default "__VITE_ASSET__ec36071b__"